import { BrowserRouter as Router, Routes, Route, Navigate, RouterProvider } from "react-router-dom"

import { AuthProvider, useAuth } from "../context/AuthProviderV2"

import { GeneralLayout } from "../layout/GeneralLayout";
import { Project } from "components/proyecto";
import ProjectWithDetails from "components/proyecto/container/ProjectWithDetails";
import Login from "auth/login";
import { Changepass } from "auth/login/container/ChangePass";
import Evaluation from "components/evaluacion/container/Evaluation";
import { RecoverPass } from "auth/login/container/RecoverPass";
import { RecoverPassStep2 } from "auth/login/container/RecoverPassStep2";
import { Confirm, Register } from "auth/register";
import { PrivacyPoliciesBox } from "auth/register/container/PrivacyPoliciesBox";
import { ConfirmPass } from "auth/login/container/ConfirmPass";
import { PrivateRoute } from "./PrivateRoutes";
import { TermsConditions } from "auth/register/container/TermsConditions";
import EncuestaComponent from "components/encuesta/container/Encuesta";
import Glosario from "components/evaluacion/container/Glosario";
import {ModeloHome, Modelo} from "@/components/evaluacion/container/Modelo";

export const WrapperRouter = () => {
    //const { isAuthenticated, isLoading } = useAuth();
    return (
        <AuthProvider>
            {/** 
            <RouterProvider router={router}/>
            */}
            <AuthWrapper />

        </AuthProvider>

    )
}

export const AuthWrapper = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <div className="min-h-screen flex items-center justify-center">Redirigiendo...</div>;
    }

    return (
        <Router>
            <Routes>
                <Route element={<GeneralLayout />}>
                    <Route path="/modelo" element={<Modelo />}></Route>
                    <Route path="/login" element={<Login />}></Route>
                    <Route path="/confirmarpassword" element={<ConfirmPass />}></Route>
                    <Route path="/recuperar" element={<RecoverPass />}></Route>
                    <Route path="/recuperarpaso2" element={<RecoverPassStep2 />}></Route>
                    <Route path="/registro" element={<Register />}></Route>
                    <Route path="/politicas" element={<PrivacyPoliciesBox />}></Route>
                    <Route path="/condiciones" element={<TermsConditions />}></Route>
                    <Route path="/confirm" element={<Confirm />}></Route>

                    {/** 🔹 Rutas protegidas (requieren sesión) */}
                    <Route element={<PrivateRoute />}>
                        <Route path="/" element={<ModeloHome />}></Route>
                        <Route path="/proyectos" element={<Project />}></Route>
                        {/*<Route path="/" element={<Project />}></Route>
                        <Route path="/proyectos" element={<ProjectWithDetails />}></Route>*/}
                        <Route path="/evaluacion" element={<Evaluation />}></Route>
                        <Route path="/glosario" element={<Glosario />}></Route>
                        <Route path="/encuesta" element={<EncuestaComponent />}></Route>
                        <Route path="/cambiarpassword" element={<Changepass />}></Route>

                    </Route>
                </Route>
            </Routes>
        </Router>)
}